var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.type},_vm._l((_vm.assignments),function(assignment,idx){return _c('div',{key:("assignment_" + idx),staticClass:"partition",style:({ height: _vm.partitionSizes[idx] })},[_c('div',{style:(_vm.partitionPatterns[idx])})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }